var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lightbox__default-loader"},[_c('div',{staticClass:"lightbox__default-loader__element"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/vagrant/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5941fc0c","hasScoped":false,"buble":{"transforms":{}}}!/home/vagrant/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/LightboxDefaultLoader.vue
// module id = 10
// module chunks = 0